import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const content = "text-center space-y-6 animate-scale-in";

const iconWrapper = "flex justify-center mb-4";

const icon = "h-16 w-16 text-muted-foreground/40";

const errorCode = "text-8xl md:text-9xl font-black text-gradient-brand";

const errorMessage = "mt-4 text-lg text-muted-foreground max-w-md mx-auto";

const dashboardLink = cn(shared.primaryButton, "mt-6 inline-flex items-center gap-2 px-6 py-2.5 shadow-md font-medium");

export { content, iconWrapper, icon, errorCode, errorMessage, dashboardLink };
